import { render } from "./availablePart.vue?vue&type=template&id=0cd858f3"
import script from "./availablePart.vue?vue&type=script&lang=js"
export * from "./availablePart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__